import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './app.css';
import { Form, Input, Button, Checkbox, Card, Avatar, Layout, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import BasicLayout from './layout';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import logo from './spsa_logo.png';
import { UserService } from '@gtpl/shared-services/attendance'
import { appSettings } from '../../../../../apps/services/config';
import { LoginResponse, UserAuthResponse } from "@gtpl/shared-models/common-models";
import CustomSpinner from "libs/shared-components/custom-spinner/src/lib/custom-spinner";
import { Route } from "react-router-dom";
import RequestForm from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/pages-visitor-management-visitor-components-visitor-request-form";
import VisitorCard from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-card";
import VisitorDetailedView from "libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-detailed-view";
import { VisitorStatusReport } from 'libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-statusreport';
import PayslipMail from "libs/pages/payroll/allowances/src/lib/normal-payslip-generation copy";
import NewLoginComponent from "./new-login-component";

const App = () => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [user_data, setUser] = useState<LoginResponse>();
  let [delayTimer, setDelayTimer] = useState(5); // secs that define when to authenticate the user in a batch of API calls
  let [lastApiCallMadeAt, setLastApiCallMadeAt] = useState(new Date().getTime());
  let [invalidAuth, setInvalidAuth] = useState(false);
  // useEffect(() => {
  //   setTimeout(() => setLoading(false), 3000)
  // }, [])
  const [load, setLoad] = useState(false);

  if (location.hash.includes('payslip-print')) {
    const pathSegments = location.hash.split('/');

    const employeeType = decodeURIComponent(pathSegments[2]);
    const yearMonth = pathSegments[3];
    const year = pathSegments[4];
    const employeeId = pathSegments[5];
    return <PayslipMail employeeType={employeeType} yearMonth={yearMonth} year={year} employeeId={employeeId} />;
}



  axios.interceptors.request.use(request => {
    setLoad(true);
    const token = JSON.parse(localStorage.getItem('accessToken'));
    if (token) {
      request.headers['Authorization'] = 'Bearer ' + token;
      // request.headers['username'] = state.user.userName;
      // request.headers['plantcode'] = state.defaultPlant;
    }
    return request;
  });

  axios.interceptors.response.use(response => {
    setLoad(false);
    return response;
  }, error => {
    setLoad(false);
    throw error;
  });

  if (location.hash.includes('visitor-card')) {
    const loc = location.hash.split('/');
    const visitorId = Number(loc[2]);
    return <VisitorCard id={visitorId}></VisitorCard>
  }

  if (location.pathname.includes('detailed-view')) {
    //  console.log(location,'##')
    return <VisitorDetailedView></VisitorDetailedView>
  }
  if (location.hash.includes('visitor-statusreport')) {
    const loc = location.hash.split('/');
    const id = Number(loc[2]);
    return <VisitorStatusReport id={id}></VisitorStatusReport>
  }
  // if (location.hash.includes('payslip-print')) {
  //   return <PayslipMail />
  // }


  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      setTimeout(() => setLoading(false), 1000)
      const foundUser = JSON.parse(loggedInUser);
      setUser(foundUser);
    }
  }, []);
  const [loading, setLoading] = useState(true);

  const service = new UserService();

  // logout the user
  const handleLogout = () => {
    setUsername("");
    setPassword("");
    localStorage.clear();
  };

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };

  const authUrl = appSettings.ums_url + '/auth/login';
  const userInfoUrl = appSettings.ums_url + '/auth/getActiveUserById';

  // login the user
  const handleSubmit = async (values) => {
    // const user = { username, password };
    // const user ={'ramakrishna':'ramakrishna'};
    // send the username and password to the server
    // const response = await axios.post("http://139.59.32.100:4000/gtpl/auth/login",values);

    const loginResponse = await axios.post(authUrl, values);
    const loginRes: LoginResponse = loginResponse.data;
    if (loginResponse.data.status) {
      // store the user in localStorage
      localStorage.setItem("user", JSON.stringify(loginRes));
      localStorage.setItem("username", JSON.stringify(loginRes.user_data.username));
      localStorage.setItem("userid", JSON.stringify(loginRes.user_data.id));
      localStorage.setItem("createdUser", loginRes.user_data.username);
      localStorage.setItem("expiresIn", JSON.stringify(loginRes.jwt.expiresIn));
      localStorage.setItem("accessToken", JSON.stringify(loginRes.jwt.accessToken));
      localStorage.setItem("role", JSON.stringify(loginRes.user_data.employeeRole));
      localStorage.setItem("unit_id", JSON.stringify(loginRes.user_data.unitId));
      localStorage.setItem("version_flag", JSON.stringify(loginRes.user_data.versionFlag));
      localStorage.setItem("plantType", JSON.stringify(loginRes.user_data.plantType));

      // set the state of the user
      setUser(loginRes);
      window.location.reload();
      AlertMessages.getSuccessMessage('Login Successful');
    } else {
      AlertMessages.getErrorMessage('Invalid Credentials');
    }
  };

  /** Authentication Begins */
  // will be called before calling any axios request
  // axios.interceptors.request.use(async request => {
  //   try {
  //     // console.log(request);
  //     // We have to check for any change in the user role/permission before triggering any API call to the server.
  //     // This will be called before each and every API call from the UI to the server ( Except for first login )
  //     if(request.url != authUrl && request.url != userInfoUrl) {
  //       let currTimeStamp = new Date().getTime();
  //       // To prevent duplicate verifications for a batch of API calls, a delay timer is maintained for a span of 'n' secs.
  //       let diffTimeStamp = currTimeStamp - lastApiCallMadeAt;
  //       if (diffTimeStamp/1000 > delayTimer) {
  //         lastApiCallMadeAt = new Date().getTime();
  //         // Then dont do any auth validation
  //         const currUserId = localStorage.getItem("userid");
  //         const currRole = localStorage.getItem("role");
  //         const vFlag = localStorage.getItem("version_flag");
  //         const userInfoRes = await axios.post(userInfoUrl, {userId: currUserId});
  //         const userInfo: UserAuthResponse = userInfoRes.data;
  //         if (!userInfo.status) {
  //           AlertMessages.getErrorMessage(userInfo.internalMessage);
  //           clearLoginInfoAndRedirect();
  //           await Promise.reject();
  //           // now check the role and version flag
  //         } else if(Number(vFlag) != Number(userInfo.data.versionFlag) || currRole != JSON.stringify(userInfo.data.employeeRole)) {
  //           // AlertMessages.getErrorMessage('User information or role has been changed. Please logout and login again');
  //           clearLoginInfoAndRedirect();
  //           await Promise.reject();
  //         }
  //       }
  //       // lastApiCallMadeAt = new Date().getTime();
  //     }
  //     return request;
  //   } catch (error) {
  //     // console.log(error);
  //     AlertMessages.getErrorMessage(error.message);
  //     Promise.reject();
  //   }
  // });

  const firstUpdate = useRef(true);
  useEffect(() => {
    // on the first time component render, we should not perform the action 
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    alert('User information or role has been changed. Logging out.. Login again');
    localStorage.clear();
    window.location.reload();
  }, [invalidAuth]);

  const clearLoginInfoAndRedirect = () => {
    setInvalidAuth(true);
  }
  /** Authentication Ends */

  // if there's a user show the message below
  if (user_data) {
    // window.location.reload();
    return (
      <>
        {loading === false ? (
          <>
            <CustomSpinner loading={load} />
            <BasicLayout key={1} user={user_data} username={username} />
          </>
        ) : (
          <div className="spin">
            <CustomSpinner loading={load} />
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {location.hash.includes('request-form') ? <RequestForm /> :

<NewLoginComponent/>

      //   <Form
      //     name="normal_login"
      //     className="container"
      //     initialValues={{
      //       remember: true,
      //     }}
      //     onFinish={handleSubmit}
      //   >

      //     <div className="bg-img">
      //       <div className="login">
      //         {/* <div>
      //     <h3 style={{color:'white', fontSize:'12px'}}>Role: Sales, [username: sales, password: sales]</h3>
      //     <h3 style={{color:'white', fontSize:'12px'}}>Role: Packing, [username: packing, password: packing]</h3>
      //     <h3 style={{color:'white', fontSize:'12px'}}>Role: Logistics, [username: logistics, password: logistics]</h3>
      //     <h3 style={{color:'white', fontSize:'12px'}}>Role: Admin, [username: admin, password: admin]</h3>
      //   </div> */}
      //         <div className="imgcontainer">
      //           <img src={logo} />
      //         </div>
      //         {/* <div style={{fontSize:'40px'}}>
      //           SPSA SILK
      //         </div> */}
      //         <header>Login </header>

      //         <Form.Item
      //           name="username"
      //           rules={[
      //             {
      //               required: true,
      //               message: 'Please input your Username!',
      //             },
      //           ]}
      //         >
      //           <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
      //         </Form.Item>


      //         <Form.Item
      //           name="password"
      //           rules={[
      //             {
      //               required: true,
      //               message: 'Please input your Password!',
      //             },
      //           ]}
      //         >
      //           <Input
      //             prefix={<LockOutlined className="site-form-item-icon" />}
      //             type="password"
      //             placeholder="Password"
      //           />
      //         </Form.Item>

      //         {/* <Form.Item>
      //   <Form.Item name="remember" valuePropName="checked" noStyle>
      //     <Checkbox>Remember me</Checkbox>
      //   </Form.Item>

      //   <a className="login-form-forgot" href="">
      //     Forgot password
      //   </a>
      // </Form.Item> */}
      //         <Form.Item>
      //           <Button type="primary" htmlType="submit" className="login-form-button ">
      //             Log in
      //           </Button>
      //           {/* Or <a href="">register now!</a> */}
      //         </Form.Item>
      //       </div>
      //     </div>

      //   </Form>
      }
    </>
  );
};

export default App;
